<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>

    <div class="nn_marketing_szoveg" v-html="marketing_szoveg" />


    <div style="width:100%; box-sizing:border-box; text-align:center; margin:30px 0px;">

        <span @click="btnOK_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
            <span><i class="fal fa-check" style="margin-right: 4px;"></i>Hozzájárulok</span>
        </span>                                        

        <span @click="btnMegsem_click" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
            <span><i class="fal fa-times" style="margin-right: 4px;"></i>Nem járulok hozzá</span>
        </span>                                        

    </div>   


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmnnmarketingnyilatkozat',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmNNMarketingNyilatkozat_",

          marketing_szoveg:"",
      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmNNMarketingNyilatkozat", pCompName);
    },

    SetLang()
    {
        this.marketing_szoveg = grcmain_GetTextBookItem("frmTagRegisztracio", "chkNyilatkozat_Marketing");
        
        this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click()
      {
        this.Mentes(1);
      },

      btnMegsem_click()
      {
        this.Mentes(0);
      },


      async Init()
      {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        this.$refs.GRCDB.HideLoading();

        console.log(Q);

        if (Q.RESULT[0].intRes == 0)
        {
            document.location = "dashboard";
        }


      },



      async Mentes(pValue)
      {

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            sIPAddress: "[IPADDRESS]",
            iValue: pValue
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Save", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        document.location = "dashboard";

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },





  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();
  }

}


</script>


<style scoped>

.nn_marketing_szoveg
{
    width:100%;
    box-sizing: border-box;
    text-align: justify;
}


</style>